import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AbModule } from '@df/module-ab/ab.module';
import { KlevuTrackCategoryProductClickDirective } from '@df/module-klevu-search/klevu-track-category-product-click.directive';
import { KlevuTrackClickDirective } from '@df/module-klevu-search/klevu-track-click.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ListingLabelComponent } from '../../../common/listing-label/listing-label.component';
import { GtmTrackClickDirective } from '../../../module/gtm/gtm-track-click.directive';
import { GtmTrackSelectItemDirective } from '../../../module/gtm/gtm-track-select-item.directive';
import { RatingComponent } from '../../../ui/common/rating.component';
import { ProductDiscountLabelComponent } from './discount-label/product-discount-label.component';
import { ProductImageComponent } from './image/product-image.component';
import { ProductListingAddToBasketExpComponent } from './listing/add-to-basket/product-listing-add-to-basket-exp.component';
import { ProductListingWishlistComponent } from './listing/wishlist/product-listing-wishlist.component';
import { ProductAbstract } from './product.abstract';
import { SwatchComponent } from './swatch/swatch.component';
import { AspectRatioPipe } from './ui/aspect-ratio.pipe';

@Component({
    selector: 'product',
    templateUrl: './product.html',
    styleUrl: './product.scss',
    standalone: true,
    imports: [
        AbModule,
        AspectRatioPipe,
        GtmTrackClickDirective,
        GtmTrackSelectItemDirective,
        HrefComponent,
        KlevuTrackCategoryProductClickDirective,
        KlevuTrackClickDirective,
        ListingLabelComponent,
        PriceComponent,
        ProductDiscountLabelComponent,
        ProductImageComponent,
        ProductListingAddToBasketExpComponent,
        ProductListingWishlistComponent,
        RatingComponent,
        RouterModule,
        SizeClassDirective,
        SwatchComponent,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductComponent extends ProductAbstract {}
